export const NEWS = 'news'
export const EVENTS = 'events'
export const WEG = 'mein_weg'
